import "./AddCategory.scss";
import { BsBookmarkPlus } from "react-icons/bs";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

import { ImUpload2 } from "react-icons/im";

import { useState } from "react";
import { swalFunc } from "../../utilities/helperFunction";
import CustomizeInputFile from "./CustomizeInputFile";
import sendRequest from "../../hooks/useAxios";

export default function AddCategory() {
  const [addCatData, setAddCatData] = useState({ file: "", title: "" });
  const [catFile, setCatFile] = useState("");

  const catHandler = (name, value) => {
    setAddCatData((prev) => {
      return { ...prev, [name]: value };
    });
  };
  const addCat = () => {
    console.log("addCat", addCatData);
  };

  return (
    <div className="add-category ">
      <Form className="mt-2">
        <Form.Group className=" input-cat-container">
          <Form.Label className="title-cat">ایجاد دسته بندی</Form.Label>
          <div className="d-flex flex-wrap justify-content-between">
            {" "}
            <span className="input-file ">
              <CustomizeInputFile
                txt="عکس دسته بندی  ..."
                Icon={ImUpload2}
                iconTxt="انتخاب عکس"
                onChange={(e) => catHandler("file", e.target.files[0])}
                id="catFile"
              />
            </span>
            <InputGroup>
              <Form.Control
                style={{ fontSize: 14, borderRadius: "0 5px 5px 0" }}
                type="text "
                placeholder="نام دسته بندی را وارد کنید..."
                className="input-cat "
                onChange={(e) => catHandler("title", e.target.value)}
              />

              <InputGroup.Text
                className=" text-center icon-cat"
                onClick={() =>
                  swalFunc(
                    "آیا از ثبت دسته بندی مطمئن هستید؟",
                    addCat,
                    "warning"
                  )
                }
              >
                <BsBookmarkPlus className="me-1" />
                ثبت
              </InputGroup.Text>
            </InputGroup>
          </div>
        </Form.Group>
      </Form>
    </div>
  );
}
